module.exports = __webpack_public_path__ + "img/home-btn.57eecca2.png";